import { fract, signStr } from '../math'

export const toFixed = (n: number, precision: number = 2): string => {
  if (fract(n) <= 0) precision = 0
  return n.toFixed(precision)
}
export const truncateNumber = (n: number, lowPrecision: number = 6, highPrecision: number = 1): string => {
  const f = fract(n);
  if (f <= 0) {
    lowPrecision = 0;
    highPrecision = 0;
  } else if (Math.abs(n) < 0.9999999) {
    const fractStr = f + '';
    if (fractStr.startsWith('00')) {
      if (lowPrecision <= 2) lowPrecision = 0;
      if (highPrecision <= 2) highPrecision = 0;
    }
  }
  
  const thousand = 1000
  const million = 1000000
  const billion = 1000000000
  const trillion = 1000000000000

  if (Math.abs(n) >= trillion) return (n / trillion).toFixed(highPrecision) + ' T'
  if (Math.abs(n) >= billion) return (n / billion).toFixed(highPrecision) + ' B'
  if (Math.abs(n) >= million) return (n / million).toFixed(highPrecision) + ' M'
  if (Math.abs(n) >= thousand) return (n / thousand).toFixed(highPrecision) + ' K'

  return n.toFixed(lowPrecision)
}

const numberToHumanReadable_ = (n: number, precision: number = 1): string => {
  const thousand = 1000
  const million = 1000000
  const billion = 1000000000
  const trillion = 1000000000000

  if (Math.abs(n) >= trillion) return (n / trillion).toFixed(precision) + ' T'
  if (Math.abs(n) >= billion) return (n / billion).toFixed(precision) + ' B'
  if (Math.abs(n) >= million) return (n / million).toFixed(precision) + ' M'
  if (Math.abs(n) >= thousand) return (n / thousand).toFixed(precision) + ' K'

  return n.toFixed(precision)
}

export const numberToHumanReadable = (
  n: number,
  precision: number = 6,
  suffix: string | undefined = undefined,
  signs: string[] = [],
  truncate: boolean = true,
  maximumFractionDigits: number = 2,
  autoPrecision: boolean = false
): string => {
  if (isNaN(n)) return 0 + '';

  const fractions = fract(n);
  // strip away fractional part if it's all zeroes
  // if (fractions <= 0) precision = 0;

  if (autoPrecision && fractions > 0) {
    if (n < 1) {
      precision = 2;
    } else {
      precision = 4;
    }
    maximumFractionDigits = precision;
  }

  const numberFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: maximumFractionDigits
  })

  const v = truncate ? numberToHumanReadable_(n, precision) : numberFormatter.format(n)

  let r = ``

  if (signs && signs.length > 0 && n > 0) {
    const s = signStr(n)
    if (signs.includes(s)) r += s
  }

  r += v

  if (suffix) {
    if (['K', 'M', 'B', 'T'].some((shorthand) => v.endsWith(shorthand))) {
      r += suffix 
    } else {
      r = `${v} ${suffix}`
    }
  }


  return r
}
